/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class CalculationConfigurationModel {

        public selectedCalculation: Wars.Domain.Model.Calculations.Calculation;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public editingCalculation: boolean;
        public isReadonly: boolean;
        public search: any;

        private systemLevel: Wars.Domain.Model.SystemLevel;
        
        constructor(
            private processConfigId,
            private calculationId: string,
            private processConfigService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private calculationService: services.CalculationService,
            private objectSchemaService: services.ObjectSchemaService,
            private deleteService: services.DeleteService,
            private growlService: angular.growl.IGrowlService)
        {
            this.editingCalculation = false;

            this.search = {
                name: ''
            }

            if (this.processConfigId) {
                this.processConfigService.getProcessConfigurationEagerLoadCalculations(this.processConfigId).then(
                (processConfiguration) => {
                    if (processConfiguration == null) {
                        this.isReadonly = true;
                        this.growlService.error("Could not find process configuration: " + this.processConfigId);
                    } else {
                        this.processConfiguration = processConfiguration;
                        if (this.processConfiguration.minorVersion != null) this.isReadonly = true;
                        if (calculationId) {
                            const match = Enumerable.from(this.processConfiguration.myCalculations).singleOrDefault(i => i.id === calculationId);
                            if (match) {
                                this.search.name = match.name;
                                this.editCalculation(match);
                            }
                        }
                    }
                });
            } else {
                this.systemLevelService.getSystemLevelCalculations().then(
                    (systemLevel) => {
                        this.systemLevel = systemLevel;
                        if (calculationId) {
                            const match = Enumerable.from(this.systemLevel.myCalculations).singleOrDefault(i => i.id === calculationId);
                            if (match) {
                                this.search.name = match.name;
                                this.editCalculation(match);
                                
                            }
                        }
                    });
            }
        }

        public getCalculations() : Array<Wars.Domain.Model.Calculations.Calculation> {
            if (this.systemLevel) return this.systemLevel.myCalculations;
            if (this.processConfiguration) return this.processConfiguration.myCalculations;
            return [];
        }

        public editCalculation(calculation: Wars.Domain.Model.Calculations.Calculation): void {
            this.editingCalculation = true;

            this.calculationService.getCalculationEagerLoadOperations(calculation.id)
                .then((calculationWithEagerLoadedFields) => this.selectedCalculation = calculationWithEagerLoadedFields);
        }

        public deleteCalculation(calculation: Wars.Domain.Model.Calculations.Calculation): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "Calculation",
                calculation.id,
                "Successfully deleted Calculation",
                () => this.getCalculations().remove(calculation),
                "Could not delete Calculation");
        }

        public addNewCalculation(): void {
            this.selectedCalculation = this.calculationService.createNewCalculation();
            this.selectedCalculation.inputSchema = this.objectSchemaService.createNewObjectSchema();
            this.selectedCalculation.objectSchema_id = this.selectedCalculation.inputSchema.id;

            this.editingCalculation = false;
        }

        public cancelSave(): void {
            this.selectedCalculation = undefined;
            this.processConfigService.rejectChanges();
            if (this.editingCalculation === false) this.getCalculations().pop();
        }

        public saveCalculation(): void {
            this.selectedCalculation.isList = this.calculationService.returnsAList(this.selectedCalculation.valueOperation);
            var validationIssues = this.calculationService.isCalculateCompleteAndValid(this.selectedCalculation);
            validationIssues = validationIssues.concat(this.objectSchemaService.validateObjectSchema(this.selectedCalculation.inputSchema));
            if (validationIssues.length > 0) {
                for (let i = 0; i < validationIssues.length; i++) {
                    this.growlService.error(validationIssues[i]);
                }
                return;
            }

            if (!this.editingCalculation) {
                this.getCalculations().push(this.selectedCalculation);
                this.editingCalculation = true;
            }

            this.calculationService.deleteEntitiesWithDeleteServiceWithoutWarning(this.deleteService).then(() => {
                this.processConfigService.saveAllChanges(() => this.saveSuccessful(), () => this.saveFailed());
            });
        }

        private saveSuccessful(): void {
            this.editingCalculation = false;
            this.selectedCalculation = undefined;
        }

        private saveFailed(): void {
            if (!this.editingCalculation) {
                this.getCalculations().pop();
            }
        }
    }
}